/* Shared timezone list — used by the AI agent editor and the call-
   routing Time Router node so both pick from the same canonical IANA
   names + human labels. */

export const TIMEZONE_GROUPS = [
  {
    label: 'United States',
    options: [
      { value: 'America/New_York',    label: 'Eastern (ET/EDT)' },
      { value: 'America/Chicago',     label: 'Central (CT/CDT)' },
      { value: 'America/Denver',      label: 'Mountain (MT/MDT)' },
      { value: 'America/Phoenix',     label: 'Arizona (MST)' },
      { value: 'America/Los_Angeles', label: 'Pacific (PT/PDT)' },
      { value: 'America/Anchorage',   label: 'Alaska (AKST/AKDT)' },
      { value: 'Pacific/Honolulu',    label: 'Hawaii (HST)' },
    ],
  },
  {
    label: 'Canada',
    options: [
      { value: 'America/Toronto',   label: 'Toronto / Ottawa (ET/EDT)' },
      { value: 'America/Winnipeg',  label: 'Winnipeg (CT/CDT)' },
      { value: 'America/Edmonton',  label: 'Edmonton / Calgary (MT/MDT)' },
      { value: 'America/Vancouver', label: 'Vancouver (PT/PDT)' },
      { value: 'America/Halifax',   label: 'Halifax (AT/ADT)' },
      { value: 'America/St_Johns',  label: "St. John's (NT/NDT)" },
    ],
  },
  {
    label: 'Mexico & Central America',
    options: [
      { value: 'America/Mexico_City', label: 'Mexico City (CST)' },
      { value: 'America/Tijuana',     label: 'Tijuana (PT/PDT)' },
      { value: 'America/Guatemala',   label: 'Guatemala (CST)' },
      { value: 'America/Panama',      label: 'Panama (EST)' },
    ],
  },
  {
    label: 'South America',
    options: [
      { value: 'America/Bogota',                    label: 'Bogotá (COT)' },
      { value: 'America/Lima',                      label: 'Lima (PET)' },
      { value: 'America/Sao_Paulo',                 label: 'São Paulo (BRT)' },
      { value: 'America/Argentina/Buenos_Aires',    label: 'Buenos Aires (ART)' },
      { value: 'America/Santiago',                  label: 'Santiago (CLT/CLST)' },
    ],
  },
  {
    label: 'Europe',
    options: [
      { value: 'Europe/London', label: 'London (GMT/BST)' },
      { value: 'Europe/Dublin', label: 'Dublin (GMT/IST)' },
      { value: 'Europe/Paris',  label: 'Paris (CET/CEST)' },
      { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)' },
      { value: 'Europe/Madrid', label: 'Madrid (CET/CEST)' },
      { value: 'Europe/Rome',   label: 'Rome (CET/CEST)' },
      { value: 'Europe/Athens', label: 'Athens (EET/EEST)' },
      { value: 'Europe/Moscow', label: 'Moscow (MSK)' },
    ],
  },
  {
    label: 'Africa & Middle East',
    options: [
      { value: 'Africa/Lagos',        label: 'Lagos (WAT)' },
      { value: 'Africa/Cairo',        label: 'Cairo (EET/EEST)' },
      { value: 'Africa/Johannesburg', label: 'Johannesburg (SAST)' },
      { value: 'Asia/Dubai',          label: 'Dubai (GST)' },
      { value: 'Asia/Riyadh',         label: 'Riyadh (AST)' },
      { value: 'Asia/Jerusalem',      label: 'Jerusalem (IST/IDT)' },
    ],
  },
  {
    label: 'Asia',
    options: [
      { value: 'Asia/Kolkata',   label: 'India (IST)' },
      { value: 'Asia/Karachi',   label: 'Karachi (PKT)' },
      { value: 'Asia/Bangkok',   label: 'Bangkok (ICT)' },
      { value: 'Asia/Singapore', label: 'Singapore (SGT)' },
      { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT)' },
      { value: 'Asia/Taipei',    label: 'Taipei (CST)' },
      { value: 'Asia/Manila',    label: 'Manila (PHT)' },
      { value: 'Asia/Shanghai',  label: 'Shanghai (CST)' },
      { value: 'Asia/Tokyo',     label: 'Tokyo (JST)' },
      { value: 'Asia/Seoul',     label: 'Seoul (KST)' },
    ],
  },
  {
    label: 'Australia',
    options: [
      { value: 'Australia/Sydney',    label: 'Sydney (AEDT/AEST)' },
      { value: 'Australia/Melbourne', label: 'Melbourne (AEDT/AEST)' },
      { value: 'Australia/Brisbane',  label: 'Brisbane (AEST)' },
      { value: 'Australia/Adelaide',  label: 'Adelaide (ACDT/ACST)' },
      { value: 'Australia/Perth',     label: 'Perth (AWST)' },
      { value: 'Australia/Darwin',    label: 'Darwin (ACST)' },
      { value: 'Australia/Hobart',    label: 'Hobart (AEDT/AEST)' },
    ],
  },
  {
    label: 'New Zealand & Pacific',
    options: [
      { value: 'Pacific/Auckland', label: 'Auckland (NZDT/NZST)' },
      { value: 'Pacific/Chatham',  label: 'Chatham Islands (CHADT/CHAST)' },
      { value: 'Pacific/Fiji',     label: 'Fiji (FJT/FJST)' },
    ],
  },
  {
    label: 'Reference',
    options: [{ value: 'UTC', label: 'UTC' }],
  },
];
